export { default } from './InactiveHoldsList';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/InactiveHoldsList/index.js